<app-filter-dropdown
  [label]="'global.filter.trailerStatus'"
  [multiple]="true"
  [formControl]="formControl"
  [options]="(options$ | async) ?? []"
  valuePath="code"
  labelPath="code"
/>